import React from 'react';
import { Card, Row, Col, Typography, Divider } from 'antd';
import hecPortrait from '../../Assets/About/Committee/nsc-hec.jpeg';
import planningPortrait from '../../Assets/About/Committee/nsc-planning.jpg';
import suparcoPortrait from '../../Assets/About/Committee/nsc-suparco.jpg';
import istVcPortrait from '../../Assets/About/Committee/nsc-ist-vc.jpg';
import istDirectorPortrait from '../../Assets/About/Committee/nsc-ist-director.png';
import ignitePortrait from '../../Assets/About/Committee/nsc-ignite.jpg';
import dynamicsPortrait from '../../Assets/About/Committee/nsc-dynamics.jpg';
import exponentPortrait from '../../Assets/About/Committee/nsc-exponent.jpg';
import ncgsaPortrait from '../../Assets/About/Committee/nsc-ncgsa.png';

const { Title, Paragraph } = Typography;

const committeeMembers = [
  { name: 'Prof. Dr. Zia Ul Haq', role: 'Executive Director, HEC (In Chair)', image: hecPortrait },
  { name: 'Dr. Najeebullah', role: 'Member, S&T & ICT, Planning Commission', image: planningPortrait },
  { name: 'Mr. M. Yousaf Khan', role: 'Chairman, SUPARCO', image: suparcoPortrait },
  { name: 'Dr. Syed Najeeb Ahmad', role: 'Vice Chancellor, IST Islamabad', image: istVcPortrait },
  { name: 'Dr. M. Jawed Iqbal', role: 'Director, IST, Karachi University', image: istDirectorPortrait },
  { name: 'Mr. Adeel Aijaz Shaikh', role: 'Chief Executive Officer, IGNITE', image: ignitePortrait },
  { name: 'Mr. Raja Sabri Khan', role: 'Chief Executive Officer, Integrated Dynamics', image: dynamicsPortrait },
  { name: 'Mr. Aftab Syed', role: 'Exponent Engineers Pvt. Ltd.', image: exponentPortrait },
  { name: 'Prof. Dr. Najam Abbas Naqvi', role: 'Chairman, NCGSA', image: ncgsaPortrait },
];

const NationalSteeringCommittee = () => (
  <section className="nsc-section">
    <div className="nsc-inner">
      <header className="nsc-header">
        <Title level={2} className="nsc-title">National Steering Committee</Title>
        <Divider className="ncgsa-divider" />
        <Paragraph className="nsc-introduction">
          National Steering Committee is a supra body which supervises the execution of the project activities and provides constructive and timely feedback to the center to continuously improve its performance. NSC comprises of the following esteemed members:
        </Paragraph>
      </header>

      <Row gutter={[32, 32]} align="stretch">
        {committeeMembers.map((member) => (
          <Col xs={24} sm={12} lg={6} key={member.name} className="nsc-column">
            <Card
              className="nsc-card"
              cover={<img src={member.image} alt={`Portrait of ${member.name}`} className="nsc-card-image" />}
            >
              <div className="nsc-card-body">
                <Title level={3} className="nsc-name">{member.name}</Title>
                <Title level={4} className="nsc-role">{member.role}</Title>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  </section>
);

export default NationalSteeringCommittee;
